
<template>
  <div>
    <div class="row mr-1 text-right">
      <div
        class="col-12 text_white text_bg_bold ml-1 pl-0 pr-0 mt-1 text-center"
      >
        <span class="ml-2">
          <input
            type="radio"
            name="free_style"
            id="freeword_gt"
            value="gt"
            v-on:change="WindowRadio"
            v-model="item_category"
          />
        </span>
        <span>
          <label for="freeword_gt">{{ $t("guitar") }}</label>
        </span>

        <span>
          <input
            type="radio"
            name="free_style"
            id="freeword_ba"
            value="ba"
            v-on:change="WindowRadio"
            v-model="item_category"
          />
        </span>
        <span>
          <label for="freeword_ba">{{ $t("bass") }}</label>
        </span>

        <span>
          <input
            type="radio"
            name="free_style"
            id="freeword_ef"
            value="ef"
            v-on:change="WindowRadio"
            v-model="item_category"
          />
        </span>
        <span>
          <label for="freeword_ef">{{ $t("ef") }}</label>
        </span>

        <span>
          <input
            type="radio"
            name="free_style"
            id="freeword_ap"
            value="ap"
            v-on:change="WindowRadio"
            v-model="item_category"
          />
        </span>
        <span>
          <label for="freeword_ap">{{ $t("amp") }}</label>
        </span>
      </div>

      <div class="col-12 text-left">
        <div class="row">
          <div class="col-8 ml-3">
            <!-- <input
              autocomplete="off"
              type="text"
              class="form-control input-lg"
              id="window_holder"
              name="window_search"
              list="autocomp_window"
              @focus="init_comp"
              v-model="window_holder"
            /> -->

            <vue-simple-suggest
              :styles="autoCompleteStyle"
              id="window_holder"
              name="window_search"
              autocomplete="off"
              v-model="window_holder"
              display-attribute="name"
              value-attribute="id"
              :list="getWindowList"
            >
            </vue-simple-suggest>
          </div>
          <div class="col-3 pl-0 pr-2">
            <button
              v-on:click="jumpSearch($event)"
              type="submit"
              id="window_send"
              style="background-color: #8c4134"
              class="btn btn-default btn-block text_white text-center"
            >
              {{ $t("search") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <datalist id="autocomp_window">
      <option
        v-for="item in list_autocomp"
        :key="item"
        v-bind:value="item"
      ></option>
    </datalist>
  </div>
</template>
<script>
export default {
  data() {
    return {
      window_holder: "",
      list_autocomp: [],
      item_category: "gt",
      request_source: "",
      default: [{ id: "", title: "" }],
      autoCompleteStyle: {
        suggestItem: "list-group-item wind",
      },
    };
  },
  props: {
    prop_input: String,
    page_state: {},
  },

  created() {
    if (
      this.page_state.category == "ele" ||
      this.page_state.category == "aco" ||
      this.page_state.category == "hollow" ||
      this.page_state.category == "gt"
    ) {
      this.item_category = "gt";
    } else if (this.page_state.category == "ef") {
      this.item_category = "ef";
    } else if (this.page_state.category == "ap") {
      this.item_category = "ap";
    } else if (this.page_state.category == "ba") {
      this.item_category = "ba";
    }

    this.window_holder = this.prop_input;
  },
  methods: {
    async getWindowList(value) {
      let str = value.replace(/[ぁ-ん]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) + 0x60);
      });

      str = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
      });

      let url = this.page_state.hppts_url + "/api/auto_comp/window";
      let data = {
        data: str,
        item_category: this.item_category,
        fake: this.page_state.fake,
      };

      var response = await axios({
        method: "post",
        url: url,
        data: data,
      })
        .then((response) => {
          if (response.status == 200) {
            return response;
          }
        })
        .catch((thrown) => {});

      return response.data;
    },

    init_comp() {
      // this.list_autocomp = [];
    },

    autocomp(value) {
      let url = this.page_state.hppts_url + "/api/auto_comp/window";
      let data = {
        data: value,
        item_category: this.item_category,
        fake: this.page_state.fake,
      };
      var promise = Promise.resolve(this.callAxios(url, data));
      promise.then((res) => {
        if (typeof res !== "undefined") {
          this.list_autocomp = res.data;
        }
      });
    },
    callAxios(url, data) {
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();

      if (this.request_source != "") {
        this.request_source.cancel();
      }
      this.request_source = source;

      return axios({
        method: "post",
        url: url,
        data: data,
        cancelToken: this.request_source.token,
      })
        .then((response) => {
          if (response.status == 200) {
            return response;
          }
        })
        .catch((thrown) => {});
    },

    WindowRadio(event) {
      this.item_category = event.target.value;
    },
    jumpSearch(e) {
      e.preventDefault();

      let url = this.page_state.locale_url;
      url += "/searching";
      url += "?search_category=" + this.item_category;
      url += "&freeword=" + this.window_holder;

      window.location.href = url;
    },
  },
  watch: {
    // window_holder: function (value) {
    //   let str = value.replace(/[ぁ-ん]/g, function (s) {
    //     return String.fromCharCode(s.charCodeAt(0) + 0x60);
    //   });
    //   str = str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function (s) {
    //     return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    //   });
    //   this.window_holder = str;
    //   this.autocomp(value);
    // },
  },
};
</script>

<style >
.wind {
  height: 125%;
  font-size: 125%;
}
</style>
